/**
 * App — the SPA root. Guards the shell behind auth (token gate → Login) and defines the
 * routes: Overview, Positions, Analytics, Funnel, Decisions, Trades, Stats and Settings
 * are fully wired.
 */
import { Navigate, Route, Routes } from 'react-router-dom';

import { AppShell } from './components/AppShell';
import { useAuth } from './auth/AuthProvider';
import { Analytics } from './routes/Analytics';
import { Decisions } from './routes/Decisions';
import { FunnelView } from './routes/Funnel';
import { Login } from './routes/Login';
import { Overview } from './routes/Overview';
import { Positions } from './routes/Positions';
import { Settings } from './routes/Settings';
import { Stats } from './routes/Stats';
import { Trades } from './routes/Trades';

export function App(): JSX.Element {
  const { authed } = useAuth();

  if (!authed) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<AppShell />}>
        <Route index element={<Overview />} />
        <Route path="/positions" element={<Positions />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/funnel" element={<FunnelView />} />
        <Route path="/decisions" element={<Decisions />} />
        <Route path="/trades" element={<Trades />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/scorecards" element={<Stats />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
